module.exports = __webpack_public_path__ + "static/img/pomwr.425a3eb4.webp";